module.exports = __webpack_public_path__ + "img/compliance.b32a2906.png";